function getProductData() {
	const script = document.querySelector('[data-vbp-product-json]');
	if (!script) {
		return null;
	}
	try {
		return JSON.parse(script.textContent);
	} catch (e) {
		return null;
	}
}

function currentSelection(root) {
	const selected = {};
	root.querySelectorAll('.c-product-detail__variant[data-axis]').forEach((group) => {
		const active = group.querySelector('.js-product-variant-opt.is-active');
		if (active) {
			selected[group.dataset.axis] = active.dataset.value;
		}
	});
	return selected;
}

function findMatchingVariant(variants, selected) {
	return variants.find((variant) => {
		const attrs = variant.attributes || {};
		return Object.keys(selected).every((axis) => attrs[axis] === selected[axis])
			&& Object.keys(attrs).every((axis) => axis in selected);
	});
}

function findLooseMatchImage(variants, selected) {
	const candidate = variants.find((variant) => {
		const attrs = variant.attributes || {};
		return Object.keys(selected).every((axis) => attrs[axis] === selected[axis]) && variant.imageUrl;
	});
	return candidate || null;
}

function getEffectivePrice(variant) {
	const priceSale = variant.priceSale || 0;
	return (priceSale > 0 && priceSale < variant.price) ? priceSale : variant.price;
}

function updateView(root, data, variant) {
	const priceEl = root.querySelector('[data-product-price]');
	const priceOldEl = root.querySelector('[data-product-price-old]');
	const saveEl = root.querySelector('[data-product-save]');
	const addButtons = root.querySelectorAll('[data-add-to-cart]');
	const stockEl = root.querySelector('[data-product-stock]');

	const STATUS_MODIFIERS = ['c-product-detail__status-green', 'c-product-detail__status-red', 'c-product-detail__status-gray'];

	if (!variant) {
		if (priceEl) priceEl.textContent = '';
		if (priceOldEl) priceOldEl.hidden = true;
		if (saveEl) saveEl.hidden = true;
		if (stockEl) {
			stockEl.textContent = 'Không có sẵn';
			stockEl.classList.remove(...STATUS_MODIFIERS);
			stockEl.classList.add('c-product-detail__status-gray');
		}
		addButtons.forEach((button) => { button.disabled = true; });
		document.dispatchEvent(new CustomEvent('vbp:variant-stock', { detail: { stock: 0 } }));
		return;
	}

	const inStock = variant.stock > 0;
	const hasPrice = variant.price > 0;
	const effectivePrice = getEffectivePrice(variant);
	const onSale = hasPrice && effectivePrice < variant.price;

	if (priceEl) {
		priceEl.textContent = hasPrice ? `${effectivePrice.toLocaleString('vi-VN')}đ` : 'Liên hệ';
	}
	if (priceOldEl) {
		priceOldEl.hidden = !onSale;
		priceOldEl.textContent = onSale ? `${variant.price.toLocaleString('vi-VN')}đ` : '';
	}
	if (saveEl) {
		saveEl.hidden = !onSale;
		saveEl.textContent = onSale ? `-${Math.round((variant.price - effectivePrice) / variant.price * 100)}%` : '';
	}
	if (stockEl) {
		stockEl.textContent = inStock ? 'Còn hàng' : 'Hết hàng';
		stockEl.classList.remove(...STATUS_MODIFIERS);
		stockEl.classList.add(inStock ? 'c-product-detail__status-green' : 'c-product-detail__status-red');
	}
	addButtons.forEach((button) => {
		button.disabled = !inStock || !hasPrice;
		button.dataset.id = data.productId;
		button.dataset.sku = variant.sku;
		button.dataset.price = effectivePrice;
		button.dataset.attributes = JSON.stringify(variant.attributes || {});
		button.dataset.image = variant.imageUrl || '';
		button.dataset.stock = variant.stock;
	});

	document.dispatchEvent(new CustomEvent('vbp:variant-stock', { detail: { stock: variant.stock } }));
}

function resolveGalleryImage(data, selected, variant) {
	if (variant && variant.imageUrl) {
		return variant;
	}
	return findLooseMatchImage(data.variants, selected);
}

function resolveAndRender(root, data, isUserAction = false) {
	const selected = currentSelection(root);
	const variant = findMatchingVariant(data.variants, selected);
	updateView(root, data, variant);

	const imageSource = resolveGalleryImage(data, selected, variant);
	if (imageSource && imageSource.imageId) {
		document.dispatchEvent(new CustomEvent('vbp:variant-image', {
			detail: { attachmentId: imageSource.imageId, isUserAction }
		}));
	}
}

function init() {
	const root = document.querySelector('.c-product-detail');
	if (!root) {
		return;
	}

	const data = getProductData();
	if (!data) {
		return;
	}

	// Depends on ui-interactions.js's click handler running first to set .is-active on the chosen option (same delegated click, no shared code).
	document.body.addEventListener('click', (e) => {
		if (e.target.closest('.js-product-variant-opt')) {
			resolveAndRender(root, data, true);
		}
	});

	resolveAndRender(root, data);
}

document.addEventListener('DOMContentLoaded', init);
